// extracted by mini-css-extract-plugin
export default {"priceContainer":"Price_priceContainer__IPPwZ","priceSale":"Price_priceSale__uj6vX","priceCrossed":"Price_priceCrossed__sRJCh","price":"Price_price__42i3F"};